import Slider from "react-slick";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {Helmet} from 'react-helmet';
import Faqs from "../Page/Faqs";
import Newsletter from "../Page/Newsletter";
import PopularHotels from "../Page/Hotels/Component/PopularHotels";
import PopularFlights from "../Page/PopularFlights";
import FlightsWidgit from "../Page/FlightsWidgit";
import Badge from "../Page/Badge";
function App1() {
  return (
   <>
    <Helmet>     
  <title>Privacy Policy, Lowest Airfare and offers | cheapflightsprices.com</title>
  <meta name="description" content="Find Cheap Flight Tickets at cheapflightsprices.com. Also Get best deals online for your summer vacation. Book your flight tickets in advance to avail the best discounts. Hurry up! Offer is valid for limited time"/>
  <meta name="keywords" content="Cheapflightsprices, Cheap Flights Prices,cheap flight booking, cheap flight fares,flight booking offer,Cheap Flights Prices,cheapest ticket booking" />
<meta property="og:description" content="Find Cheap Flight Tickets at cheapflightsprices.com. Also Get best deals online for your summer vacation. Book your flight tickets in advance to avail the best discounts. Hurry up! Offer is valid for limited time" />
<meta property="og:site_name" content="Cheap Flights Prices, Lowest Airfare and offers | cheapflightsprices.com" />
<meta name="twitter:title" content="Cheap Flights Prices, Lowest Airfare and offers | cheapflightsprices.com" />
<meta name="twitter:description" content="Find Cheap Flight Tickets at cheapflightsprices.com. Also Get best deals online for your summer vacation. Book your flight tickets in advance to avail the best discounts. Hurry up! Offer is valid for limited time" />
<meta name="Distribution" content="Global" />
<meta name="Robots" content="follow, index, all" />
<meta name="googlebot" content="index, follow" />
<meta http-equiv="Expires" content="never" />
<meta name="document-type" content="public" />
<meta name="revisit-after" content="daily" />
<meta name="country" content="India" />
<meta name="Language" content="English" />
<meta name='rating' content="general" />
<meta name="author" content="cheapflightsprices.com" />
<link rel="canonical" href="https://cheapflightsprices.com/terms-and-conditions.html" />
  </Helmet>
   <section id="banner_section" className="innerbannersection">
    <div className="hero-container" data-aos="zoom-in" data-aos-delay="100">
      <h1 className="mb-2 pb-0">Cheap Flights</h1>
      <h2>Cheap Flights Prices Booking Start @ $24</h2>
      <FlightsWidgit/>
    </div>
  </section>
<Badge/>
 

    <main id="main">
    <section id="mainsection" className="section-with-bg">
     <div class="container" data-aos="fade-up">
  <div class="section-header">
    <h2><strong>Terms &amp; Conditions</strong></h2>
  </div>
  <div class="designcontainer">

    <p><em>(Updated version. By using this website, you agree to the following Terms & Conditions. If you do not agree, please discontinue use immediately.)</em></p>

    <h4>What We Do</h4>
    <p>
      CheapFlightsPrices.com provides you with a travel search and comparison service.
      When you submit a search request, our system contacts a number of partners – including but not limited to airlines, hotels, and travel agencies
      (collectively referred to as <strong>“Our Partners”</strong>) – and returns a list of available options. You can then browse, filter, and click a result,
      at which point you are redirected to the selected Partner’s website. All bookings and payments are completed directly with Our Partners.
    </p>

    <p>
      We update the website and its functionality regularly, including adding or removing Partners from our results, at our discretion.
    </p>

    <p>
      Our service is provided for personal, non-commercial use only. Any commercial use requires explicit agreement and enrollment into our affiliate program.
    </p>

    <h4>What We Don’t Do</h4>
    <p>
      We <strong>do not sell tickets, hotels, or travel products directly</strong>. Our website only provides comparison tools and booking links.
      Payments, refunds, and customer service are handled entirely by the Partner on their own website. Please contact the respective Partner for
      booking changes, cancellations, or inquiries.
    </p>

    <p>
      We do not endorse or recommend one ticket, booking, or Partner over another. All results are displayed objectively based on the data provided
      by Our Partners. Decisions remain solely with you, the user.
    </p>

    <h4>Prohibited Use</h4>
    <p>
      - Users under the age of 13 may not use this website without parental or guardian supervision.<br/>
      - Running automated scripts, bots, or spam queries is strictly prohibited.<br/>
      - You may not misuse our trademarks, logos, design elements, or content without written authorization.<br/>
      - Misrepresenting yourself as CheapFlightsPrices.com or acting on our behalf without authorization is not permitted.
    </p>

    <h4>Limitation of Liability</h4>
    <p>
      CheapFlightsPrices.com provides its services free of charge. To the maximum extent permitted by applicable law, we disclaim liability for any damages,
      losses, or issues arising from the use of our website or from your dealings with Our Partners.
    </p>

    <h4>Indemnification</h4>
    <p>
      By using this website, you agree to indemnify and hold harmless CheapFlightsPrices.com and its affiliates against any claims, damages, or losses
      brought by third parties as a result of your misuse of the website or any violation of these Terms & Conditions.
    </p>

    <h4>Affiliate Disclosure</h4>
    <p>
      CheapFlightsPrices.com participates in affiliate partnerships. This means we may earn a commission when you book through links on our site.
      This does not affect the price you pay. All prices are shown in <strong>USD</strong> and may vary based on availability, exchange rates,
      and Partner policies.
    </p>

  </div>
</div>

    </section>
    <PopularFlights/>
        <PopularHotels />
    <Faqs/>
    <Newsletter/>
      </main>
    </>
  );
}
export default App1;
